
"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

const preventDefault = (event: { preventDefault: () => void }) => {
  event.preventDefault()
}

const noop = () => {}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, dismissible = true, ...props }) {
        // Non-dismissible toasts (upload/download progress) own their own
        // lifecycle: no close button, and every Radix close path is inert.
        // Radix Root is controlled here, so swallowing onOpenChange ignores
        // close requests (Escape, swipe) without preventing the key event
        // itself, which would stop an open dialog closing on the same Escape.
        // The swipe handlers are prevented purely so the toast cannot be
        // dragged off screen while it stays open.
        const pinnedProps = dismissible
          ? null
          : {
              onOpenChange: noop,
              onSwipeStart: preventDefault,
              onSwipeMove: preventDefault,
              onSwipeCancel: preventDefault,
              onSwipeEnd: preventDefault,
            }
        return (
          <Toast key={id} {...props} {...pinnedProps} className={dismissible ? undefined : "pr-6"}>
            <div className="grid gap-1 flex-1 min-w-0">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            {dismissible && <ToastClose />}
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
